import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { ImagesService } from '../images.service';
import { OverlayService } from '../../services/overlay.service';
import { Store } from '../../store';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-images',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit, OnDestroy {
    @Input() allowSelection: false;
    @Input() type;
    @Input() ownerId;
    @Output() imageSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() modalAction: EventEmitter<any> = new EventEmitter<any>();

    overlays$ = this.store.select<any>('overlays');
    body = document.getElementsByTagName('body')[0];

    images = [];
    types = [];
    imageType;
    pagination: any;
    user: any;

    modals = {
        update: false,
        create: false,
        delete: false
    };

    modalData: any = {
    };

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
        event: KeyboardEvent
    ) {
        this.cancel();
    }

    constructor(
        private imagesService: ImagesService,
        private overlayService: OverlayService,
        private store: Store,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit() {
        this.pagination = this.imagesService.getPagination();
        this.getTypes();
        this.body.classList.add('body-freeze', 'modal-open');
    }

    ngOnDestroy(): void {
        this.body.classList.remove('body-freeze', 'modal-open');
    }

    drop(e) {
        // moveItemInArray(this.images, event.previousIndex, event.currentIndex);
        this.updateSortOrder();
    }

    updateSortOrder() {
        this.imagesService.updateSortOrder(this.images).subscribe();
    }

    getImages() {
        this.imagesService.get(this.type, this.ownerId).subscribe(data => {
            this.images = data.data;
        });
    }

    getTypes() {
        this.imagesService.getTypes().subscribe(data => {
            this.types = data.data;
            for (let i = 0; i < this.types.length; i++) {
                if (this.type === this.types[i].id) {
                    this.imageType = this.types[i];
                }
            }
            this.type = this.imageType.id;
            this.getImages();
        });
    }

    setType(type) {
        this.imageType = type;
        this.type = type.id;
        this.getImages();
    }
    // delete(image) {
    //     image.edit = false;
    //     this.imagesService.delete(image).subscribe(data => {
    //         const idx = this.images.indexOf(image);
    //         this.images.splice(idx, 1);
    //     });
    // }

    selectImage(image) {
        this.imageSelected.emit(image);
    }

    appendImage(e) {
        this.images.push(e.data);
        if (this.allowSelection) {
            this.selectImage(e.data);
        }
    }

    delete(item) {
        this.overlayService.open('imageDelete');
        this.modals.delete = true;
        this.modalData = item;
    }

    deleteResponse(event) {
        this.modals.delete = event.active;
        if (event.success) {
            for (let i = 0; i < this.images.length; i++) {
                if (this.images[i].id === this.modalData.id) {
                    this.images.splice(i, 1);
                }
            }
        }
    }

    copyUrl(copyText) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = copyText;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.toastrService.info('Image URL copied');
    }

    toggleMenu(image) {
        image.menuOpen = !image.menuOpen;
    }

    toggleMoveMenu(image) {
        image.moveOpen = !image.moveOpen;
    }

    move(image, type, idx) {
        this.toggleMoveMenu(image);
        image.type = type.id;
        this.imagesService.move(image).subscribe(data => {
            this.images.splice(idx, 1);
        });
    }

    cropImage(image) {
        this.store.set('cropImage', image);
        this.overlayService.open('imageCropper');
    }

    cancel() {
        const dataToEmit = {
            completed: false
        };
        this.modalAction.emit(dataToEmit);
    }
}
